<template>
  <section class="container">
    <div
      v-if="PageInfo.data.length"
      class="course"
    >
      <div class="course__block">
        <router-link
          v-for="item in PageInfo.data"
          :key="item.courseId"
          class="course__item"
          :to="`/course/classRoom/${ item.courseId }`"
        >
          <div
            class="course__image"
            :style="{ 'background-image': `url(${ item.mainImagePath })` }"
          />

          <div class="course__content">
            <p class="course__title">
              <span>{{ item.courseName }}</span>
            </p>

            <p v-if="item.teacherName" class="course__teacher">
              <span>{{ $t('course.label.by') }} {{ item.teacherName }}</span>
            </p>

            <div class="course__info">
              <span v-if="item.totalVideoDuration">
                {{ $t('course.info.totalDuration', { hours: item.totalVideoDuration }) }}
              </span>

              <span class="course__price-origin">
                NT$ {{ item.courseOriPrice | toCurrency }}
              </span>
            </div>

            <div class="course__price">
              <span v-if="item.buyersCount" class="course__buyersCount">
                <i class="fa fa-user-plus" />{{ item.buyersCount | toCurrency }}
              </span>

              <span class="course__price-sale">
                NT$ {{ item.coursePrice | toCurrency }}
              </span>
            </div>

            <div class="course__button">
              <button class="course-button" @click.prevent="AddToCar(item.courseId)">
                {{ $t('common.button.addToCart') }}
              </button>
            </div>
          </div>
        </router-link>
      </div>

      <div class="pagination pagination--center">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page.sync="Pagination.pageIndex"
          :page-size="Pagination.pageSize"
          :total="PageInfo.count"
          @current-change="GetData()"
        />
      </div>
    </div>

    <div v-if="PageInfo.data.length === 0" class="empty">
      <p>{{ $t('search.message.noResults') }}</p>
    </div>
  </section>
</template>

<script>
import { GetBuyCourseSearch } from '@/api/BuyCourseApi';

export default {
  data() {
    return {
      Pagination: {
        // 預設從第幾頁開始
        pageIndex: 1,
        // 預設每頁幾筆
        pageSize: 9,
        data: {
          searchContent: '',
        },
      },
      PageInfo: {
        // api給的總筆數
        count: 0,
        data: [],
      },
    };
  },
  watch: {
    $route() {
      this.GetData();
    },
  },
  created() {
    // ('對應傳送端的emit方法','接收的參數')
    this.$bus.$on('reSearchCourse', (str) => {
      this.GetData(str);
    });

    this.GetData();
  },
  beforeDestroy() {
    // 取消reSearchCourse事件定義
    this.$bus.$off('reSearchCourse');
  },
  methods: {
    GetData(str = '') {
      this.Pagination.data.searchContent = str || this.$route.query.searchContent;
      GetBuyCourseSearch(this.Pagination).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfo.count = response.data.count;
          this.PageInfo.data = response.data.data;
        }
      });
    },
    AddToCar(id) {
      this.$bus.$emit('addShoppingCart', id);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
